import { ScheduleItemV2 } from '@hopin-team/api-hopin';
import { differenceInDays, format, startOfDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

/* Parses dates and strips off timezone offset
 * For example - normally `new Date('2020-01-01');` would return `Tue Dec 31 2019 20:00:00 GMT-0400 (Atlantic Standard Time)`
 * This helper will return `Wed Jan 01 2020 00:00:00 GMT-0400 (Atlantic Standard Time)`
 */
export const getLocalisedDate = (date: string) => {
  const offset = format(new Date(date), 'xx');
  return utcToZonedTime(date, offset);
};

export const getLocalisedDateTimeLabels = (
  item: ScheduleItemV2,
  locale: Locale,
  getFormattedTime: (date: Date) => string,
) => {
  const timeStart = getLocalisedDate(item.time_start);
  const timeEnd = getLocalisedDate(item.time_end);

  const startDateTimeLabel = format(timeStart, 'PPP p z', {
    locale,
  });

  const startTimeLabel = getFormattedTime(timeStart);
  const endTimeLabel = getFormattedTime(timeEnd);

  const endTimeDaysIncrement = differenceInDays(
    startOfDay(timeEnd),
    startOfDay(timeStart),
  );

  return {
    startDateTimeLabel,
    startTimeLabel,
    endTimeLabel,
    endTimeDaysIncrement,
  };
};
